import React from 'react';

import Header from '../../../components/Header';

import { Wrapper } from './styles';

export default function DefaulLayout({ children }) {
  return (
    <Wrapper>
      <Header />
      {children}
    </Wrapper>
  );
}